module.exports = __webpack_public_path__ + "static/media/contactSvg.26db66a3.svg";